
    import Component from "vue-class-component";
    import Vue from "vue";
    import {CountryModel, SysAdminCountriesClient } from "@/api-client";
    import { BvTableFieldArray } from "bootstrap-vue";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
    import HeadingWave from "@/features/shared/components/HeadingWave.vue";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import PopoverInfo from "@/components/PopoverInfo.vue";
    import {debounceFn} from "debounce-decorator-ts";
    import {NavigationGuardNext} from "vue-router/types/router";
    import {Prop} from "vue-property-decorator";

    interface Props {
        preloadedCountries: CountryModel[];
    }

    @Component({
        components: {
            TableEmptySlot,
            HeadingWave,
            SectionPageHeading,
            PopoverInfo,
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<Countries>) {
        const props = to.meta!.props as Props;
        Promise.all([
            new SysAdminCountriesClient().list()
        ]).then(values => {
            props.preloadedCountries = values[0];
            next();
        }).catch(e => next(e))
    }
    })
    export default class Countries extends Vue {
        @Prop({ required: true })
        preloadedCountries!: CountryModel[];

        countries: CountryModel[] = this.preloadedCountries;
        filteredCountries = this.countries;

        searchPhrase = "";

        async created() {
            this.getParametersFromRouteOrDefault();

            this.$watch(() => this.searchPhrase, () => {
                this.reflectParametersToRoute();
            });

            this.$watch(() => this.$route.query, () => {
                this.search();
            }, { deep: true, immediate: true });
        }

        search() {
            const lowerCaseSearchPhrase = this.searchPhrase.toLowerCase();
            this.filteredCountries = this.countries.filter(o =>
                o.nameEst.toLowerCase().indexOf(lowerCaseSearchPhrase) >= 0
                || o.nameEng.toLowerCase().indexOf(lowerCaseSearchPhrase) >= 0
                || o.nameEstPossessiveCase.toLowerCase().indexOf(lowerCaseSearchPhrase) >= 0
                || o.nameEngPossessiveCase.toLowerCase().indexOf(lowerCaseSearchPhrase) >= 0);
        }

        @debounceFn(100) // Prevents possible double-update
        reflectParametersToRoute(): void {
            this.$router.replace({
                query: {
                    // Setting to 'undefined' removes parameter from URL.
                    searchPhrase: this.searchPhrase || undefined
                }
            });
        }

        getParametersFromRouteOrDefault() {
            const route = this.$route as any;
            const query = route.query;
            this.searchPhrase = query.searchPhrase ? query.searchPhrase : '';
        }

        fields: BvTableFieldArray = [
            { key: "numericCode", label: this.$ls.Administration_Countries_Table_Label_NumericCode, sortable: true },
            { key: "letterCode", label: this.$ls.Administration_Countries_Table_Label_LetterCode, sortable: true },
            { key: "nameEst", label: this.$ls.Global_Label_NameEst, sortable: true },
            { key: "nameEng", label: this.$ls.Global_Label_NameEng, sortable: true },
            { key: "nameEstPossessiveCase", label: this.$ls.Administration_Countries_Table_Label_NameEstPossessiveCase, sortable: true },
            { key: "nameEngPossessiveCase", label: this.$ls.Administration_Countries_Table_Label_NameEngPossessiveCase, sortable: true },
        ];
    }
